//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'hilda01',
    colors: ['#ec5526', '#f4ac12', '#9ebbc1', '#f7f4e2'],
    stroke: '#1e1b1e',
    background: '#e7e8d4',
    type: 'hilda',
  },
  {
    name: 'hilda02',
    colors: ['#eb5627', '#eebb20', '#4e9eb8', '#f7f5d0'],
    stroke: '#201d13',
    background: '#77c1c0',
    type: 'hilda',
  },
  {
    name: 'hilda03',
    colors: ['#e95145', '#f8b917', '#b8bdc1', '#ffb2a2'],
    stroke: '#010101',
    background: '#6b7752',
    type: 'hilda',
  },
  {
    name: 'hilda04',
    colors: ['#e95145', '#f6bf7a', '#589da1', '#f5d9bc'],
    stroke: '#000001',
    background: '#f5ede1',
    type: 'hilda',
  },
  {
    name: 'hilda05',
    colors: ['#ff6555', '#ffb58f', '#d8eecf', '#8c4b47', '#bf7f93'],
    stroke: '#2b0404',
    background: '#ffda82',
    type: 'hilda',
  },
  {
    name: 'hilda06',
    colors: ['#f75952', '#ffce84', '#74b7b2', '#f6f6f6', '#b17d71'],
    stroke: '#0e0603',
    background: '#f6ecd4',
    type: 'hilda',
  },
];
